import { createFileRoute } from "@tanstack/react-router";
import YouveTriedEverything from "@/pages/articles/YouveTriedEverything";
export const Route = createFileRoute(
  "/youve-tried-everything-why-is-the-depression-still-here",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Why Is the Depression Still Here? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Tried everything and the depression is still here? Learn about TMS, SAINT TMS, and next options for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Why Is the Depression Still Here? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Tried everything and the depression is still here? Learn about TMS, SAINT TMS, and next options for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/youve-tried-everything-why-is-the-depression-still-here",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/youve-tried-everything-why-is-the-depression-still-here",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <YouveTriedEverything />;
}
